import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service"; // Servisinizin yolu

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // 🔓 Token kontrolüne takılmayacak, herkese açık API adresleri (Beyaz Liste)
    // Sizin backend endpoint isimlerinizle birebir eşleşmelidir
    const publicUrls = [
      "/api/auth/forgot",
      "/api/auth/reset",
      "/api/auth/login",
      "/api/auth/register",
    ];

    // Eğer atılan istek bu public url'lerden birini içeriyorsa,
    // hiçbir işlem yapmadan (token eklemeden) isteği direkt backend'e fırlat
    const isPublic = publicUrls.some((url) => request.url.includes(url));

    if (isPublic) {
      return next.handle(request);
    }

    let token = this.authService.getToken();

    // Eğer token varsa isteği klonlayıp header ekliyoruz
    if (token) {
      token = token.replace(/^"|"$/g, "");
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request);
  }
}
